import * as React from "react";
const SvgPublishIcon = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M5 4v2h14V4H5zm0 10h4v6h6v-6h4l-7-7-7 7z", fill: "currentColor" }));
export default SvgPublishIcon;
